import React, { PropsWithChildren, Suspense } from 'react';
import { FullscreenLoadingSpinner } from '@/shared/components/FullscreenLoadingSpinner.tsx';

export function FullscreenLoadingSuspenseBoundary({ children }: PropsWithChildren) {
    return <Suspense fallback={<FullscreenLoadingSpinner />}>{children}</Suspense>;
}
